export default function TermsAndConditionsRoute() {
	return (
		<main className="p-6">
			<div>
				<div className="mb-4 flex items-center justify-between">
					<span className="text-lg font-bold leading-[18pt]">
						Website Terms and Conditions
					</span>
					<span className="text-sm leading-[18pt]">
						Page <span className="currentPageNum">1</span> of{' '}
						<span className="totalPageNum">1</span>
					</span>
				</div>

				<div className="mb-4 text-center">
					<p className="text-lg font-bold leading-[18pt] underline">
						TERMS AND CONDITIONS
					</p>
				</div>

				<div className="text-left">
					<p className="font-serif text-base leading-[18pt] text-black">
						These terms and conditions (the "Terms and Conditions") govern the
						use of
						<span className="font-bold"> chadcluff.com</span> (the "Site"). This
						Site is owned and operated by Chad Cluff. This Site is a personal
						webiste & portfolio.
						<br />
						<br />
						By using this Site, you indicate that you have read and understand
						these Terms and Conditions and agree to abide by them at all times.
					</p>
				</div>

				<div className="mt-4 text-left">
					<p className="font-serif text-base font-bold leading-[18pt] text-black underline">
						Intellectual Property
					</p>
					<p className="font-serif text-base leading-[18pt] text-black">
						All content published and made available on our Site is the property
						of Chad Cluff and the Site's creators. This includes, but is not
						limited to images, text, logos, documents, downloadable files and
						anything that contributes to the composition of our Site.
					</p>
				</div>

				<div className="mt-4 text-left">
					<p className="font-serif text-base font-bold leading-[18pt] text-black underline">
						Acceptable Use
					</p>
					<p className="font-serif text-base leading-[18pt] text-black">
						As a user of our Site, you agree to use our Site legally, not to use
						our Site for illegal purposes, and not to:
					</p>
					<ul className="list-disc pl-6">
						<li className="mb-4">
							Harass or mistreat other users of our Site;
						</li>
						<li className="mb-4">
							Violate the rights of other users of our Site;
						</li>
						<li className="mb-4">
							Violate the intellectual property rights of the Site owners or any
							third party to the Site;
						</li>
						<li className="mb-4">
							Hack into the account of another user of the Site;
						</li>
						<li className="mb-4">
							Act in any way that could be considered fraudulent; or
						</li>
						<li>
							Post any material that may be deemed inappropriate or offensive.
						</li>
					</ul>
					<p className="font-serif text-base leading-[18pt] text-black">
						If we believe you are using our Site illegally or in a manner that
						violates these Terms and Conditions, we reserve the right to limit,
						suspend or terminate your access to our Site. We also reserve the
						right to take any legal steps necessary to prevent you from
						accessing our Site.
					</p>
				</div>

				{/* Other sections follow the same pattern */}
				{/* You can replicate the structure for other sections like "Third Party Goods and Services", "Limitation of Liability", etc. */}

				<div className="mt-4 text-left">
					<p className="font-serif text-base font-bold leading-[18pt] text-black underline">
						Contact Details
					</p>
					<p className="font-serif text-base leading-[18pt] text-black">
						Please contact us if you have any questions or concerns. Our contact
						details are as follows:
						<br />
						<br />
						______________________________________
						<br />
						______________________________________
						<br />
						______________________________________
					</p>
					<p className="font-serif text-base leading-[18pt] text-black">
						You can also contact us through the feedback form available on our
						Site.
					</p>
				</div>

				<div className="mt-6 text-right">
					<p className="font-serif text-base leading-[18pt] text-black">
						Effective Date: 8 day of August, 2024
					</p>
				</div>
			</div>
		</main>
	)
}
